import eventBus from '~/events/eventBus'
import eventDefinitions from '~/events/eventDefinitions'

eventBus.$on(eventDefinitions.USER.REGISTERED, ({ user }) => {
  if (user) {
    window.dataLayer.push({
      event: eventDefinitions.USER.REGISTERED,
      user_id: user.id,
      user_groups: user.groups,
    })
  }
})
